import React from 'react'
import Coder from '../../pages/Coder/Coder'

const AuditorCodingScreen = () => {
  return (
    <>
      <Coder/>
    </>
  )
}

export default AuditorCodingScreen
